export default "__VITE_ASSET__5ba18d90__"